'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'cat';
var width = 576;
var height = 512;
var aliases = [128008];
var unicode = 'f6be';
var svgPathData = ['M96 416l0 64 224 0 0-32-80 0 0-56c0-22.1-17.9-40-40-40l-24 0 0-32 24 0c39.8 0 72 32.2 72 72l0 10.1 119.1-79.4 24.9-16.6 0 173.9 32 0 0-228c-10.2 2.6-21 4-32 4-47.2 0-88.4-25.5-110.6-63.5-116.9 7.5-209.4 104.7-209.4 223.5zM320 17.3L320 128c0 53 43 96 96 96s96-43 96-96l0-110.7-54 43.2-4.4 3.5-75.2 0-4.4-3.5-54-43.2zM396 128a20 20 0 1 1 -40 0 20 20 0 1 1 40 0zm80 0a20 20 0 1 1 -40 0 20 20 0 1 1 40 0z', 'M544 128c0 47.4-25.7 88.7-64 110.8l0 273.2-96 0 0-146.1-75.2 50.1 43.2 0 0 96-288 0 0-336c0-26.5-21.5-48-48-48l-16 0 0-32 16 0c44.2 0 80 35.8 80 80l0 116.1c39.4-71.1 111.8-121.5 196.4-130.6-2.9-10.7-4.4-21.9-4.4-33.5l0-177.3C297.1-42.1 330.9-15 389.6 32l52.8 0c58.7-47 92.6-74 101.6-81.3L544 128zM305.4 192.5C188.5 200 96 297.2 96 416l0 64 224 0 0-32-80 0 0-56c0-22.1-17.9-40-40-40l-24 0 0-32 24 0c39.8 0 72 32.2 72 72l0 10.1 119.1-79.4 24.9-16.6 0 173.9 32 0 0-228c-10.2 2.6-21 4-32 4-47.2 0-88.4-25.5-110.6-63.5zM458 60.5l-4.4 3.5-75.2 0-4.4-3.5-54-43.2 0 110.7c0 53 43 96 96 96s96-43 96-96l0-110.7-54 43.2zM376 148a20 20 0 1 1 0-40 20 20 0 1 1 0 40zm80 0a20 20 0 1 1 0-40 20 20 0 1 1 0 40z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;